import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { cssMainSelector } from "../lib/cssSelectors";
import { Label } from "./Label";
import Currency from "./Currency";
import styled from "styled-components";

const FreeLabel = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.color.darkOliveGreen};
    background-color: ${p => p.theme.color.lightGoldenRodyel};
  }
`;

class PriceUpfront extends PureComponent {
  render() {
    return (
      <span className={`${CSS_CLASS_PREFIX}-price-upfront`}>
        {this.upfrontContent()}
      </span>
    );
  }

  upfrontContent() {
    const { amount, portal, replaceZeros, t } = this.props;

    if (amount > 0) {
      return (
        <span>
          <Currency
            amount={amount}
            portal={portal}
            replaceZeros={replaceZeros}
          />{" "}
          <span className={`${CSS_CLASS_PREFIX}-price-upfront-text`}>
            {this.upfrontText()}
          </span>
        </span>
      );
    } else if (amount === 0) {
      return <FreeLabel>{t("free")}</FreeLabel>;
    } else {
      return null;
    }
  }

  upfrontText() {
    const { short, t } = this.props;

    if (short) {
      return t("upfrontShort");
    } else {
      return t("upfront");
    }
  }
}

PriceUpfront.propTypes = {
  amount: PropTypes.number.isRequired,
  portal: PropTypes.object.isRequired,
  replaceZeros: PropTypes.bool,
  short: PropTypes.bool
};

PriceUpfront.defaultProps = {
  replaceZeros: false
};

export default withTranslation(["priceUpfront"])(PriceUpfront);
